document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('jt-floral-plan-form');
  const datesContainer = document.getElementById('jt-plan-dates');
  const addDateButton = document.getElementById('jt-plan-add-date');
  const countElement = document.getElementById('jt-plan-count');
  const totalElement = document.getElementById('jt-plan-total');
  const variantInput = document.getElementById('jt-plan-variant-id');
  const planDataInput = document.getElementById('jt-plan-data');
  const productDataElement = document.getElementById('plan-product-data');

  if (!form || !datesContainer || !addDateButton || !productDataElement) {
    return;
  }

  let productData;

  try {
    productData = JSON.parse(productDataElement.textContent);
  } catch (error) {
    console.error('Unable to read floral plan product data.', error);
    return;
  }

  const MIN_DATES = 3;
  const MAX_DATES = 12;
  const PREPARATION_BUSINESS_DAYS = 5;

  const TIME_WINDOWS = [
    '12 PM–1 PM',
    '1 PM–2 PM',
    '2 PM–3 PM',
    '3 PM–4 PM',
    '4 PM–5 PM',
    '5 PM–6 PM'
  ];

  const FIXED_OCCASIONS = [
    'Valentine’s Day',
    'Mother’s Day',
    'Easter',
    'Qixi',
    'Thanksgiving',
    'Christmas'
  ];

  const QIXI_DATES = {
    2026: '2026-08-19',
    2027: '2027-08-08',
    2028: '2028-08-26',
    2029: '2029-08-16',
    2030: '2030-08-05',
    2031: '2031-08-24',
    2032: '2032-08-12'
  };


  /* ========================================
     BASIC DATE HELPERS
  ======================================== */

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function formatDateValue(date) {
    return [
      date.getFullYear(),
      pad(date.getMonth() + 1),
      pad(date.getDate())
    ].join('-');
  }

  function parseLocalDate(value) {
    if (!value) return null;

    const parts = value.split('-').map(Number);

    if (parts.length !== 3) return null;

    return new Date(
      parts[0],
      parts[1] - 1,
      parts[2],
      12,
      0,
      0,
      0
    );
  }

  function cloneDate(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      12,
      0,
      0,
      0
    );
  }

  function addCalendarDays(date, days) {
    const result = cloneDate(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function getToday() {
    const today = new Date();

    return new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      12,
      0,
      0,
      0
    );
  }

  function datesEqual(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function formatDisplayDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }


  /* ========================================
     5 PREPARATION BUSINESS DAYS

     Preparation:
     Mon–Fri count.
     Sat/Sun do not count.

     Sunday can count as preparation,
     even though Sunday is not a
     fulfillment day.
  ======================================== */

  function isPreparationBusinessDay(date) {
    const day = date.getDay();

    return day >= 1 && day <= 5;
  }

  function getEarliestPreparedDate() {
    let cursor = getToday();
    let counted = 0;

    while (counted < PREPARATION_BUSINESS_DAYS) {
      cursor = addCalendarDays(cursor, 1);

      if (isPreparationBusinessDay(cursor)) {
        counted++;
      }
    }

    return cursor;
  }


  /* ========================================
     FEDERAL HOLIDAY HELPERS
  ======================================== */

  function nthWeekdayOfMonth(year, month, weekday, nth) {
    const first = new Date(year, month, 1, 12);
    const offset = (weekday - first.getDay() + 7) % 7;

    return new Date(
      year,
      month,
      1 + offset + (nth - 1) * 7,
      12
    );
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    const last = new Date(year, month + 1, 0, 12);

    const offset =
      (last.getDay() - weekday + 7) % 7;

    last.setDate(last.getDate() - offset);

    return last;
  }

  function observedFixedHoliday(year, month, day) {
    const actual = new Date(year, month, day, 12);

    if (actual.getDay() === 6) {
      return addCalendarDays(actual, -1);
    }

    if (actual.getDay() === 0) {
      return addCalendarDays(actual, 1);
    }

    return actual;
  }

  function getFederalHolidayDates(year) {
    const holidays = [];

    // New Year's Day
    const newYearsActual = new Date(year, 0, 1, 12);

    holidays.push(newYearsActual);
    holidays.push(
      observedFixedHoliday(year, 0, 1)
    );

    // Martin Luther King Jr. Day
    holidays.push(
      nthWeekdayOfMonth(year, 0, 1, 3)
    );

    // Washington's Birthday / Presidents Day
    holidays.push(
      nthWeekdayOfMonth(year, 1, 1, 3)
    );

    // Memorial Day
    holidays.push(
      lastWeekdayOfMonth(year, 4, 1)
    );

    // Juneteenth
    const juneteenthActual =
      new Date(year, 5, 19, 12);

    holidays.push(juneteenthActual);
    holidays.push(
      observedFixedHoliday(year, 5, 19)
    );

    // Independence Day
    const independenceActual =
      new Date(year, 6, 4, 12);

    holidays.push(independenceActual);
    holidays.push(
      observedFixedHoliday(year, 6, 4)
    );

    // Labor Day
    holidays.push(
      nthWeekdayOfMonth(year, 8, 1, 1)
    );

    // Columbus Day
    holidays.push(
      nthWeekdayOfMonth(year, 9, 1, 2)
    );

    // Veterans Day
    const veteransActual =
      new Date(year, 10, 11, 12);

    holidays.push(veteransActual);
    holidays.push(
      observedFixedHoliday(year, 10, 11)
    );

    // Thanksgiving
    holidays.push(
      nthWeekdayOfMonth(year, 10, 4, 4)
    );

    // Christmas
    const christmasActual =
      new Date(year, 11, 25, 12);

    holidays.push(christmasActual);
    holidays.push(
      observedFixedHoliday(year, 11, 25)
    );

    // Observed New Year's Day for next year,
    // when observation falls in December.
    const nextNewYearObserved =
      observedFixedHoliday(year + 1, 0, 1);

    if (nextNewYearObserved.getFullYear() === year) {
      holidays.push(nextNewYearObserved);
    }

    return holidays;
  }

  function isFederalHoliday(date) {
    return getFederalHolidayDates(
      date.getFullYear()
    ).some(holiday => datesEqual(holiday, date));
  }


  /* ========================================
     FULFILLMENT AVAILABILITY

     Fulfillment:
     Tue–Sun
     12 PM–6 PM

     Closed:
     Sunday
     Federal holidays
  ======================================== */

  function isSunday(date) {
    return date.getDay() === 1;
  }

  function isFulfillmentOpen(date) {
    if (isSunday(date)) {
      return false;
    }

    if (isFederalHoliday(date)) {
      return false;
    }

    return true;
  }

  function isPreparedInTime(date) {
    return date >= getEarliestPreparedDate();
  }

  function isSelectableFulfillmentDate(date) {
    return (
      isPreparedInTime(date) &&
      isFulfillmentOpen(date)
    );
  }


  /* ========================================
     OCCASION DATES
  ======================================== */

  function mothersDay(year) {
    return nthWeekdayOfMonth(year, 4, 0, 2);
  }

  function thanksgiving(year) {
    return nthWeekdayOfMonth(year, 10, 4, 4);
  }

  function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor(
      (a + 11 * h + 22 * l) / 451
    );

    const month = Math.floor(
      (h + l - 7 * m + 114) / 31
    );

    const day =
      ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(
      year,
      month - 1,
      day,
      12
    );
  }

  function getOccasionDate(occasion, year) {
    switch (occasion) {
      case 'Valentine’s Day':
        return new Date(year, 1, 14, 12);

      case 'Mother’s Day':
        return mothersDay(year);

      case 'Easter':
        return easterSunday(year);

      case 'Qixi':
        return QIXI_DATES[year]
          ? parseLocalDate(QIXI_DATES[year])
          : null;

      case 'Thanksgiving':
        return thanksgiving(year);

      case 'Christmas':
        return new Date(year, 11, 25, 12);

      default:
        return null;
    }
  }


  /* ========================================
     NEAREST OPEN DATES
  ======================================== */

  function findPreviousOpenDate(date) {
    let cursor = addCalendarDays(date, -1);

    for (let i = 0; i < 14; i++) {
      if (isFulfillmentOpen(cursor)) {
        return cursor;
      }

      cursor = addCalendarDays(cursor, -1);
    }

    return null;
  }

  function findNextOpenDate(date) {
    let cursor = addCalendarDays(date, 1);

    for (let i = 0; i < 14; i++) {
      if (isFulfillmentOpen(cursor)) {
        return cursor;
      }

      cursor = addCalendarDays(cursor, 1);
    }

    return null;
  }


  /* ========================================
     RESOLVE FIXED OCCASION
  ======================================== */

  function resolveFixedOccasion(occasion) {
    const earliest = getEarliestPreparedDate();
    const currentYear = getToday().getFullYear();

    for (
      let year = currentYear;
      year <= currentYear + 7;
      year++
    ) {
      const occasionDate =
        getOccasionDate(occasion, year);

      if (!occasionDate) {
        continue;
      }

      /*
        Normal open date:
        lock directly to occasion date.
      */
      if (isFulfillmentOpen(occasionDate)) {
        if (occasionDate >= earliest) {
          return {
            mode: 'locked',
            occasionDate,
            options: [],
            reason: ''
          };
        }

        continue;
      }

      /*
        Occasion is on Sunday or holiday:
        find nearest open date before and after.
      */
      const before =
        findPreviousOpenDate(occasionDate);

      const after =
        findNextOpenDate(occasionDate);

      const options = [];

      if (
        before &&
        before >= earliest
      ) {
        options.push({
          date: before,
          position: 'before'
        });
      }

      if (
        after &&
        after >= earliest
      ) {
        options.push({
          date: after,
          position: 'after'
        });
      }

      if (options.length > 0) {
        return {
          mode: 'choice',
          occasionDate,
          options,
          reason: isSunday(occasionDate)
            ? 'sunday'
            : 'holiday'
        };
      }
    }

    return null;
  }


  /* ========================================
     VALENTINE NOTE
  ======================================== */

  function updateValentineNote(card) {
    const occasion =
      card.querySelector('.jt-plan-occasion')?.value;

    const note =
      card.querySelector('.jt-plan-valentine-alert');

    if (!note) return;

    note.hidden =
      occasion !== 'Valentine’s Day';
  }


  /* ========================================
     CLOSURE NOTE
  ======================================== */

  function hideClosureNote(card) {
    const note =
      card.querySelector('.jt-plan-closure-alert');

    if (!note) return;

    note.hidden = true;
    note.innerHTML = '';
  }

  function showClosureNote(card, occasion, result) {
    const note =
      card.querySelector('.jt-plan-closure-alert');

    if (!note || !result) return;

    const originalDate =
      formatDisplayDate(result.occasionDate);

    let heading;
    let message;

    if (result.reason === 'sunday') {
      heading = 'Sunday Closure';

      message =
        `${occasion} falls on ${originalDate}. ` +
        `Je T’aime Blooms is closed on Sundays. ` +
        `Please choose one of the available fulfillment dates.`;
    } else {
      heading = 'Holiday Closure';

      message =
        `${occasion} falls on ${originalDate}, when ` +
        `Je T’aime Blooms is closed for the holiday. ` +
        `Please choose one of the available fulfillment dates.`;
    }

    note.innerHTML = `
      <strong>${heading}</strong>
      <span>${message}</span>
    `;

    note.hidden = false;
  }


  /* ========================================
     SINGLE VARIETY
  ======================================== */

  function updateSingleVarietyOptions(card) {
    const style =
      card.querySelector('.jt-plan-style')?.value;

    const section =
      card.querySelector('.jt-plan-single-options');

    const flower =
      card.querySelector('.jt-plan-flower');

    if (!section || !flower) return;

    const isSingle =
      style === 'Single Variety';

    section.hidden = !isSingle;
    flower.required = isSingle;

    if (!isSingle) {
      flower.value = '';

      const colors =
        card.querySelector('.jt-plan-colors-avoid');

      if (colors) {
        colors.value = '';
      }
    }
  }


  /* ========================================
     DATE UI
  ======================================== */

  function resetDateUI(card) {
    const dateInput =
      card.querySelector('.jt-plan-date-input');

    const dateChoice =
      card.querySelector('.jt-plan-date-choice');

    const helper =
      card.querySelector('.jt-plan-date-helper');

    if (dateInput) {
      dateInput.hidden = false;
      dateInput.disabled = false;
      dateInput.readOnly = false;
      dateInput.value = '';
      dateInput.min =
        formatDateValue(
          getEarliestPreparedDate()
        );
    }

    if (dateChoice) {
      dateChoice.hidden = true;
      dateChoice.disabled = true;
      dateChoice.innerHTML = '';
    }

    if (helper) {
      helper.hidden = true;
      helper.textContent = '';
    }

    hideClosureNote(card);
  }


  /* ========================================
     APPLY FIXED OCCASION
  ======================================== */

  function applyFixedOccasion(card, occasion) {
    const dateInput =
      card.querySelector('.jt-plan-date-input');

    const dateChoice =
      card.querySelector('.jt-plan-date-choice');

    const helper =
      card.querySelector('.jt-plan-date-helper');

    const result =
      resolveFixedOccasion(occasion);

    if (!result) {
      resetDateUI(card);

      dateInput.hidden = true;
      dateInput.disabled = true;

      if (helper) {
        helper.hidden = false;
        helper.textContent =
          'This occasion is not currently available for online scheduling. Please contact us.';
      }

      updateTimeOptions(card);
      return;
    }


    /*
      NORMAL FIXED OCCASION

      Show only the date input.
      Hide alternative date selector completely.
    */
    if (result.mode === 'locked') {
      dateInput.hidden = false;
      dateInput.disabled = false;
      dateInput.readOnly = true;
      dateInput.value =
        formatDateValue(result.occasionDate);

      dateChoice.hidden = true;
      dateChoice.disabled = true;
      dateChoice.innerHTML = '';

      hideClosureNote(card);

      if (helper) {
        helper.hidden = false;
        helper.textContent =
          `Automatically scheduled for ${occasion}.`;
      }

      updateTimeOptions(card);
      return;
    }


    /*
      CLOSED FIXED OCCASION

      Hide normal date input completely.
      Show only before/after selector.
    */
    dateInput.hidden = true;
    dateInput.disabled = true;
    dateInput.readOnly = false;
    dateInput.value = '';

    dateChoice.hidden = false;
    dateChoice.disabled = false;

    dateChoice.innerHTML =
      '<option value="">Choose a fulfillment date</option>';

    result.options.forEach(optionData => {
      const option =
        document.createElement('option');

      option.value =
        formatDateValue(optionData.date);

      const direction =
        optionData.position === 'before'
          ? 'Before'
          : 'After';

      option.textContent =
        `${formatDisplayDate(optionData.date)} — ${direction}`;

      dateChoice.appendChild(option);
    });

    if (helper) {
      helper.hidden = true;
      helper.textContent = '';
    }

    showClosureNote(
      card,
      occasion,
      result
    );

    updateTimeOptions(card);
  }


  /* ========================================
     OCCASION CHANGE
  ======================================== */

  function handleOccasionChange(card) {
    const occasion =
      card.querySelector('.jt-plan-occasion')?.value;

    resetDateUI(card);
    updateValentineNote(card);

    if (FIXED_OCCASIONS.includes(occasion)) {
      applyFixedOccasion(
        card,
        occasion
      );
    } else {
      const dateInput =
        card.querySelector('.jt-plan-date-input');

      if (dateInput) {
        dateInput.min =
          formatDateValue(
            getEarliestPreparedDate()
          );
      }
    }

    updateTimeOptions(card);
    updatePlanData();
  }


  /* ========================================
     CURRENT DATE VALUE
  ======================================== */

  function getCardDateValue(card) {
    const choice =
      card.querySelector('.jt-plan-date-choice');

    if (
      choice &&
      !choice.hidden
    ) {
      return choice.value || '';
    }

    return (
      card.querySelector('.jt-plan-date-input')
        ?.value || ''
    );
  }


  /* ========================================
     TIME OPTIONS
  ======================================== */

  function updateTimeOptions(card) {
    const timeSelect =
      card.querySelector('.jt-plan-time');

    if (!timeSelect) return;

    const dateValue =
      getCardDateValue(card);

    const previous =
      timeSelect.value;

    timeSelect.innerHTML =
      '<option value="">Select a time</option>';

    if (!dateValue) {
      timeSelect.disabled = true;
      return;
    }

    const date =
      parseLocalDate(dateValue);

    if (
      !date ||
      !isSelectableFulfillmentDate(date)
    ) {
      timeSelect.disabled = true;
      return;
    }

    TIME_WINDOWS.forEach(window => {
      const option =
        document.createElement('option');

      option.value = window;
      option.textContent = window;

      timeSelect.appendChild(option);
    });

    timeSelect.disabled = false;

    if (TIME_WINDOWS.includes(previous)) {
      timeSelect.value = previous;
    }
  }


  /* ========================================
     MANUAL DATE VALIDATION
  ======================================== */

  function validateManualDate(card, showAlert = true) {
    const input =
      card.querySelector('.jt-plan-date-input');

    const occasion =
      card.querySelector('.jt-plan-occasion')?.value;

    if (
      !input ||
      !input.value ||
      FIXED_OCCASIONS.includes(occasion)
    ) {
      return true;
    }

    const date =
      parseLocalDate(input.value);

    if (!date) {
      return false;
    }

    if (!isPreparedInTime(date)) {
      input.value = '';

      if (showAlert) {
        alert(
          'Please choose a date that allows at least 5 business days for preparation.'
        );
      }

      updateTimeOptions(card);

      return false;
    }

    if (isSunday(date)) {
      input.value = '';

      if (showAlert) {
        alert(
          'Je T’aime Blooms is closed on Sundays. Please choose another date.'
        );
      }

      updateTimeOptions(card);

      return false;
    }

    if (isFederalHoliday(date)) {
      input.value = '';

      if (showAlert) {
        alert(
          'Je T’aime Blooms is closed on this holiday. Please choose another date.'
        );
      }

      updateTimeOptions(card);

      return false;
    }

    return true;
  }


  /* ========================================
     CREATE DATE CARD
  ======================================== */

  function createDateCard() {
    const card =
      document.createElement('div');

    card.className =
      'jt-plan-date-card';

    card.innerHTML = `
      <div class="jt-plan-date-card__header">

        <span class="jt-plan-date-card__number">
          DATE
        </span>

        <button
          type="button"
          class="jt-plan-date-card__remove"
        >
          Remove
        </button>

      </div>


      <div class="jt-plan-date-card__grid">

        <div class="jt-plan-date-card__field">

          <label>
            Occasion *
          </label>

          <select
            class="jt-plan-occasion"
            required
          >
            <option value="">
              Select an occasion
            </option>

            <option value="Birthday">
              Birthday
            </option>

            <option value="Anniversary">
              Anniversary
            </option>

            <option value="Valentine’s Day">
              Valentine’s Day
            </option>

            <option value="Mother’s Day">
              Mother’s Day
            </option>

            <option value="Easter">
              Easter
            </option>

            <option value="Qixi">
              Qixi
            </option>

            <option value="Thanksgiving">
              Thanksgiving
            </option>

            <option value="Christmas">
              Christmas
            </option>

            <option value="Custom Date">
              Custom Date
            </option>

          </select>

        </div>


        <div class="jt-plan-date-card__field">

          <label>
            Date *
          </label>

          <input
            type="date"
            class="jt-plan-date-input"
            min="${formatDateValue(getEarliestPreparedDate())}"
            required
          >

          <select
            class="jt-plan-date-choice"
            hidden
            disabled
          ></select>

          <p
            class="jt-plan-date-helper"
            hidden
          ></p>

        </div>


        <div
          class="jt-plan-valentine-alert"
          hidden
        >

          <strong>
            Valentine’s Day Note
          </strong>

          <span>
            Your plan already includes a complimentary Medium
            Valentine’s arrangement, valued at $199. This paid
            Valentine’s Day selection will be prepared as an
            additional $250 arrangement in a different design.
          </span>

        </div>


        <div
          class="jt-plan-closure-alert"
          hidden
        ></div>


        <div class="jt-plan-date-card__field">

          <label>
            Requested Time *
          </label>

          <select
            class="jt-plan-time"
            required
            disabled
          >
            <option value="">
              Select a date first
            </option>
          </select>

        </div>


        <div class="jt-plan-date-card__field">

          <label>
            Arrangement *
          </label>

          <select
            class="jt-plan-arrangement"
            required
          >
            <option value="">
              Select a format
            </option>

            <option value="Bouquet">
              Bouquet
            </option>

            <option value="Flower Box">
              Flower Box
            </option>
          </select>

        </div>


        <div class="jt-plan-date-card__field">

          <label>
            Floral Style *
          </label>

          <select
            class="jt-plan-style"
            required
          >
            <option value="">
              Select a style
            </option>

            <option value="Mixed">
              Mixed
            </option>

            <option value="Single Variety">
              Single Variety
            </option>
          </select>

        </div>


        <div
          class="jt-plan-single-options"
          hidden
        >

          <div class="jt-plan-single-options__grid">

            <div class="jt-plan-date-card__field">

              <label>
                Flower *
              </label>

              <select class="jt-plan-flower">

                <option value="">
                  Select a flower
                </option>

                <option value="Roses">
                  Roses
                </option>

                <option value="Hydrangeas">
                  Hydrangeas
                </option>

                <option value="Sunflowers">
                  Sunflowers
                </option>

              </select>

            </div>


            <div class="jt-plan-date-card__field">

              <label>
                Colors to Avoid — Optional
              </label>

              <input
                type="text"
                class="jt-plan-colors-avoid"
                placeholder="e.g. Red, orange"
              >

            </div>

          </div>


          <p class="jt-plan-single-note">
            Single-variety arrangements will be designed in one
            cohesive color. Final color selection is based on
            seasonal availability, excluding any colors noted above.
          </p>

        </div>

          <div class="jt-plan-message-card">

            <div class="jt-plan-date-card__field">

              <label>
                Message Card — Optional
              </label>

              <textarea
                class="jt-plan-message"
                rows="3"
                placeholder="Write a short message..."
              ></textarea>

              <div class="jt-plan-message-meta">

                <span>
                  Up to 10 words · Emojis welcome ♡
                </span>

                <span class="jt-plan-message-count">
                  0 / 10 words
                </span>

              </div>

              <p class="jt-plan-message-note">
                Leave blank and we’ll include a blank message card.
              </p >

            </div>

          </div>

      </div>
    `;


    const occasionSelect =
      card.querySelector('.jt-plan-occasion');

    const dateInput =
      card.querySelector('.jt-plan-date-input');

    const dateChoice =
      card.querySelector('.jt-plan-date-choice');

    const styleSelect =
      card.querySelector('.jt-plan-style');

    const removeButton =
      card.querySelector(
        '.jt-plan-date-card__remove'
      );

    const messageInput =
      card.querySelector('.jt-plan-message');

    const messageCount =
      card.querySelector('.jt-plan-message-count');

    function getMessageWords(value) {
      return value
        .trim()
        .split(/\s+/)
        .filter(word => {
          if (!word) return false;

          // Standalone emojis and punctuation do not count as words.
          return /[\p{L}\p{N}]/u.test(word);
        });
    }

    function updateMessageCount() {
      if (!messageInput || !messageCount) return;

      const words =
        getMessageWords(messageInput.value);

      messageCount.textContent =
        `${words.length} / 10 words`;
    }

    if (messageInput) {
      let previousMessage = '';

      messageInput.addEventListener('input', () => {
        const words =
          getMessageWords(messageInput.value);

        if (words.length > 10) {
          messageInput.value = previousMessage;
        } else {
          previousMessage = messageInput.value;
        }

        updateMessageCount();
        updatePlanData();
      });
    }

    occasionSelect.addEventListener(
      'change',
      () => handleOccasionChange(card)
    );


    dateInput.addEventListener(
      'change',
      () => {
        validateManualDate(card);
        updateTimeOptions(card);
        updatePlanData();
      }
    );


    dateChoice.addEventListener(
      'change',
      () => {
        updateTimeOptions(card);
        updatePlanData();
      }
    );


    styleSelect.addEventListener(
      'change',
      () => {
        updateSingleVarietyOptions(card);
        updatePlanData();
      }
    );


    card
      .querySelectorAll('select, input')
      .forEach(field => {

        field.addEventListener(
          'change',
          updatePlanData
        );

        field.addEventListener(
          'input',
          updatePlanData
        );

      });


    removeButton.addEventListener(
      'click',
      () => {

        const cards =
          getDateCards();

        if (cards.length <= MIN_DATES) {
          return;
        }

        card.remove();
        refreshPlan();

      }
    );


    datesContainer.appendChild(card);

    refreshPlan();
  }


  /* ========================================
     CARDS
  ======================================== */

  function getDateCards() {
    return Array.from(
      datesContainer.querySelectorAll(
        '.jt-plan-date-card'
      )
    );
  }


  /* ========================================
     VARIANT
  ======================================== */

  function findVariantForCount(count) {
    if (
      !productData ||
      !Array.isArray(productData.variants)
    ) {
      return null;
    }

    const expected =
      `${count} Dates`;

    let variant =
      productData.variants.find(item =>
        String(item.option1)
          .trim()
          .toLowerCase() ===
        expected.toLowerCase()
      );

    if (!variant) {
      variant =
        productData.variants.find(item =>
          parseInt(
            String(item.option1),
            10
          ) === count
        );
    }

    return variant || null;
  }


  /* ========================================
     COLLECT DATA
  ======================================== */

  function collectPlanData() {
    return getDateCards().map(
      (card, index) => {

        const style =
          card.querySelector(
            '.jt-plan-style'
          )?.value || '';

        return {
          number: index + 1,

          occasion:
            card.querySelector(
              '.jt-plan-occasion'
            )?.value || '',

          date:
            getCardDateValue(card),

          time:
            card.querySelector(
              '.jt-plan-time'
            )?.value || '',

          arrangement:
            card.querySelector(
              '.jt-plan-arrangement'
            )?.value || '',

          floralStyle:
            style,

          flower:
            style === 'Single Variety'
              ? (
                  card.querySelector(
                    '.jt-plan-flower'
                  )?.value || ''
                )
              : '',

          colorsToAvoid:
            style === 'Single Variety'
              ? (
                  card.querySelector(
                   '.jt-plan-colors-avoid'
                  )?.value.trim() || ''
                )
              : '',

         message:
           card.querySelector(
              '.jt-plan-message'
           )?.value.trim() || ''
        };
      }
    );
  }

  function updatePlanData() {
    if (!planDataInput) return;

    planDataInput.value =
      JSON.stringify(
        collectPlanData()
      );
  }


  /* ========================================
     REFRESH PLAN
  ======================================== */

  function refreshPlan() {
    const cards =
      getDateCards();

    cards.forEach(
      (card, index) => {

        const numberElement =
          card.querySelector(
            '.jt-plan-date-card__number'
          );

        const removeButton =
          card.querySelector(
            '.jt-plan-date-card__remove'
          );

        if (numberElement) {
          numberElement.textContent =
            `DATE ${String(
              index + 1
            ).padStart(2, '0')}`;
        }

        if (removeButton) {
          removeButton.style.display =
            cards.length > MIN_DATES
              ? ''
              : 'none';
        }

      }
    );


    const count =
      cards.length;

    if (countElement) {
      countElement.textContent =
        String(count);
    }

        const variant =
      findVariantForCount(count);

    if (totalElement && variant) {
      const price = Number(variant.price) / 100;
      const compareAtPrice =
        variant.compare_at_price
          ? Number(variant.compare_at_price) / 100
          : null;

      const formatMoney = amount =>
        `$${amount.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })}`;

      if (
        compareAtPrice &&
        compareAtPrice > price
      ) {
        totalElement.innerHTML = `
          <span class="jt-plan-total-original">
            ${formatMoney(compareAtPrice)}
          </span>
          <span class="jt-plan-total-sale">
            ${formatMoney(price)}
          </span>
        `;
      } else {
        totalElement.innerHTML = `
          <span class="jt-plan-total-sale">
            ${formatMoney(price)}
          </span>
        `;
      }
    }

    if (variantInput) {
      variantInput.value =
        variant
          ? variant.id
          : '';
    }


    addDateButton.disabled =
      count >= MAX_DATES;

    addDateButton.style.display =
      count >= MAX_DATES
        ? 'none'
        : '';


    updatePlanData();
  }


  /* ========================================
     ADD DATE
  ======================================== */

  addDateButton.addEventListener(
    'click',
    () => {

      if (
        getDateCards().length >= MAX_DATES
      ) {
        return;
      }

      createDateCard();

    }
  );


  /* ========================================
     VALIDATION
  ======================================== */

  function validatePlan() {
    const cards =
      getDateCards();

    if (cards.length < MIN_DATES) {
      alert(
        'Please select at least 3 dates.'
      );

      return false;
    }


    for (
      let index = 0;
      index < cards.length;
      index++
    ) {
      const card =
        cards[index];

      const occasion =
        card.querySelector(
          '.jt-plan-occasion'
        )?.value;

      const dateValue =
        getCardDateValue(card);

      const time =
        card.querySelector(
          '.jt-plan-time'
        )?.value;

      const arrangement =
        card.querySelector(
          '.jt-plan-arrangement'
        )?.value;

      const floralStyle =
        card.querySelector(
          '.jt-plan-style'
        )?.value;


      if (
        !occasion ||
        !dateValue ||
        !time ||
        !arrangement ||
        !floralStyle
      ) {
        alert(
          `Please complete all required selections for Date ${index + 1}.`
        );

        return false;
      }


      const date =
        parseLocalDate(dateValue);

      if (
        !date ||
        !isSelectableFulfillmentDate(date)
      ) {
        alert(
          `Please choose an available fulfillment date for Date ${index + 1}.`
        );

        return false;
      }


      if (
        floralStyle === 'Single Variety'
      ) {
        const flower =
          card.querySelector(
            '.jt-plan-flower'
          )?.value;

        if (!flower) {
          alert(
            `Please choose a flower for Date ${index + 1}.`
          );

          return false;
        }
      }
    }


    const variant =
      findVariantForCount(
        cards.length
      );

    if (!variant) {
      alert(
        `The ${cards.length}-date plan is currently unavailable.`
      );

      return false;
    }


    return true;
  }


  /* ========================================
     ADD TO CART
  ======================================== */

  form.addEventListener(
    'submit',
    async event => {

      event.preventDefault();

      if (!validatePlan()) {
        return;
      }


      const cards =
        getDateCards();

      const variant =
        findVariantForCount(
          cards.length
        );

      if (!variant) return;


      const plan =
        collectPlanData();



      /*
        Sort selected dates from nearest to furthest
        before creating cart properties.
      */
      const sortedPlan = [...plan].sort((a, b) => {
        const dateA = parseLocalDate(a.date);
        const dateB = parseLocalDate(b.date);

        if (!dateA && !dateB) return 0;
        if (!dateA) return 1;
        if (!dateB) return -1;

        return dateA - dateB;
      });


      const properties = {
        _jt_floral_plan: 'true'
      };


      sortedPlan.forEach((item, index) => {

        const lines = [
          `Date: ${item.date}`,
          `Requested Time: ${item.time}`,
          `Arrangement: ${item.arrangement}`,
          `Floral Style: ${item.floralStyle}`
        ];


        if (
          item.floralStyle === 'Single Variety'
        ) {
          lines.push(
            `Flower: ${item.flower}`
          );

          if (item.colorsToAvoid) {
            lines.push(
              `Colors to Avoid: ${item.colorsToAvoid}`
            );
          }
        }

        lines.push(
          `Message: ${item.message || 'Blank card'}`
        );


        properties[
          `Date ${index + 1} — ${item.occasion}`
        ] = lines.join('\n');

      });


      properties[
        'Complimentary Valentine’s Gift'
      ] =
        'Included — Medium Valentine’s Collection arrangement · $199 value';

      properties[
        'Payment Type'
      ] =
        'One-time payment · No automatic renewal';


      const submitButton =
        form.querySelector(
          '.jt-floral-plan-button'
        );

      const originalText =
        submitButton.textContent;


      submitButton.disabled = true;
      submitButton.textContent =
        'Adding...';


      try {
        const response =
          await fetch('/cart/add.js', {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              items: [
                {
                  id:
                    Number(variant.id),

                  quantity: 1,

                  properties
                }
              ]
            })
          });


        if (!response.ok) {
          throw new Error(
            'Unable to add floral plan to cart.'
          );
        }


        window.location.href =
          '/cart';

      } catch (error) {
        console.error(error);

        alert(
          'We couldn’t add your floral plan to the cart. Please try again.'
        );

        submitButton.disabled = false;
        submitButton.textContent =
          originalText;
      }
    }
  );


  /* ========================================
     INITIAL 3 DATES
  ======================================== */

  for (
    let i = 0;
    i < MIN_DATES;
    i++
  ) {
    createDateCard();
  }

  refreshPlan();
});